import React from "react";
import { MessageCircle } from "lucide-react";
export const WhatsAppButton = () => {
  const phoneNumber = "40736718154"; // Format: country code + number
  const whatsappUrl = `https://wa.me/${phoneNumber}`;
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-20 right-6 z-50 flex items-center gap-2 px-4 py-3 bg-emerald-600 text-white rounded-full shadow-lg hover:bg-emerald-700 transition-colors" aria-label="Chat on WhatsApp" data-id="element-406">
      <MessageCircle className="h-5 w-5" data-id="element-407" />
      <span className="font-medium" data-id="element-408">Chat with us</span>
    </a>;
};